import { Skeleton } from "@/components/ui/skeleton";

const WasteSummaryLoader = (): JSX.Element => {
  return (
    <div className='flex flex-col space-y-3 my-2'>
      <Skeleton className='h-[350px] w-full' />
      <div className='grid grid-cols-2 gap-3'>
        <Skeleton className='h-[310px] w-full' />
        <Skeleton className='h-[310px] w-full' />
      </div>
      <Skeleton className='h-[310px] w-full' />
    </div>
  );
};

export default WasteSummaryLoader;
